/* Plain numbers, formatted once and in one place.
 *
 * `i18n.md` bans formatting a number by hand, and the reason is not cosmetic:
 * the grouping and decimal separators swap between locales, so `1.234` is one
 * thousand two hundred in Turkish and roughly one and a quarter in English.
 * `String(n)` produces the English answer everywhere.
 *
 * Money does NOT come through here — it is integer minor units plus a currency
 * code and has its own formatter in `packages/domain`, because the digit count
 * belongs to the currency rather than to the locale (ADR-0005). Two number
 * paths would be one too many; these are two different things.
 */
/** A whole count — a limit, a tally, a headcount. */
export function formatCount(value, { locale }) {
    return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value);
}
//# sourceMappingURL=numbers.js.map